import { useMenuStore } from '~/modules/menu/stores/menuStore';
import { useMenuCategoriesStore } from '~/modules/menu/stores/menuCategoriesStore';

import convertMenuToCategories from '~/modules/menu/utils/convertMenuToCategories';

import type { ICategoryItem } from '~/modules/categories/types/categories';

export const useMenu = () => {
  const { $api } = useNuxtApp() as NuxtAppType;
  const { rewriteHeadCategories, rewriteMenu } = useMenuStore();
  const { rewriteMenuList, rewriteProductCategoriesList } = useMenuCategoriesStore();

  /**
   * @deprecated
   */
  const updateMenu = async (): Promise<void> => {
    try {
      const response = await $api.menu.getMenu();

      if (response.data.items) {

        // todo плохо
        const result: ICategoryItem[] = convertMenuToCategories(response.data.items);

        rewriteMenu(response.data);
        rewriteHeadCategories(result);
      } else {
        console.warn('Данные меню не были получены');
      }

    } catch (error: unknown) {
      throw error;
    }
  };

  const updateMenuCategories = async (): Promise<void> => {
    try {
      const response = await $api.menu.getCategoriesMenu();

      if (response.data.items) {
        rewriteMenuList(response.data);

      } else {
        console.warn('Данные меню не были получены');
      }

    } catch (error: unknown) {
      throw error;
    }
  };

  const updateProductCategories = async (): Promise<void> => {
    try {
      const response = await $api.categories.getProductCategories();

      if (response.data) {
        rewriteProductCategoriesList(response.data);

      } else {
        console.warn('Данные меню не были получены');
      }

    } catch (error: unknown) {
      throw error;
    }
  };

  return {
    updateMenu,
    updateMenuCategories,
    updateProductCategories,
  };
};
